import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://sgecrzhklzwypbtiwjxh.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNnZWNyemhrbHp3eXBidGl3anhoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE3Nzk0MTMsImV4cCI6MjA4NzM1NTQxM30.mPtOfWQeruUSfeMmKqSk6BqVxatxaZ0P4rSuYrTCRnI";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

/**
 * Legge il ruolo dell'utente dalla tabella app_users (lookup via email).
 *
 * Ritorna sempre un oggetto con questi campi (mai null):
 *   - isAdmin (boolean): true solo se app_users ha is_admin=true E attivo=true
 *   - nome    (string | null): nome utente se trovato
 *   - email   (string | null): email utente se trovata
 *   - trovato (boolean): true se l'utente è presente in app_users e attivo
 *
 * In caso di errore o utente non trovato, ritorna default sicuro (isAdmin=false)
 * e logga un warning in console. Non lancia mai eccezioni.
 */
export async function getUserRole(email) {
  const defaultRole = { isAdmin: false, nome: null, email: null, trovato: false };

  if (!email) {
    console.warn("[AUTH] getUserRole chiamato senza email");
    return defaultRole;
  }

  try {
    const { data, error } = await supabase
      .from("app_users")
      .select("email, nome, is_admin, attivo")
      .eq("email", email)
      .eq("attivo", true)
      .maybeSingle();

    if (error) {
      console.warn("[AUTH] Errore lettura app_users:", error.message);
      return defaultRole;
    }

    if (!data) {
      console.warn(`[AUTH] Utente ${email} non trovato in app_users (o non attivo)`);
      return defaultRole;
    }

    return {
      isAdmin: !!data.is_admin,
      nome: data.nome || null,
      email: data.email || null,
      trovato: true,
    };
  } catch (e) {
    console.warn("[AUTH] Eccezione in getUserRole:", e?.message || e);
    return defaultRole;
  }
}
